module.exports = __webpack_public_path__ + "torre-logo.png?ab1f1033937c535dd99eba686ece0434";


//////////////////
// WEBPACK FOOTER
// ./src/assets/torre-logo.png
// module id = 201
// module chunks = 0